import { render, staticRenderFns } from "./lastPosts.vue?vue&type=template&id=69ea5e7b&"
import script from "./lastPosts.vue?vue&type=script&lang=ts&"
export * from "./lastPosts.vue?vue&type=script&lang=ts&"
import style0 from "./lastPosts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports